module.exports = __webpack_public_path__ + "img/coins-agree-popup-bg.7709b2f8.png";